package com.patronat.top.ui.theme

import org.jetbrains.compose.resources.DrawableResource
import top.design_system.generated.resources.Res
import top.design_system.generated.resources.img_onboarding_discover
import top.design_system.generated.resources.img_onboarding_filters_map
import top.design_system.generated.resources.img_onboarding_reviews
import top.design_system.generated.resources.img_onboarding_share
import top.design_system.generated.resources.img_onboarding_start
import top.design_system.generated.resources.img_sign_up_1
import top.design_system.generated.resources.img_sign_up_2
import top.design_system.generated.resources.img_sign_up_3

object AppImages {
    val OnboardingDiscover: DrawableResource
        get() = Res.drawable.img_onboarding_discover

    val OnboardingReviews: DrawableResource
        get() = Res.drawable.img_onboarding_reviews

    val OnboardingShare: DrawableResource
        get() = Res.drawable.img_onboarding_share

    val OnboardingFiltersMap: DrawableResource
        get() = Res.drawable.img_onboarding_filters_map

    val OnboardingStart: DrawableResource
        get() = Res.drawable.img_onboarding_start

    val SignUp1: DrawableResource
        get() = Res.drawable.img_sign_up_1

    val SignUp2: DrawableResource
        get() = Res.drawable.img_sign_up_2

    val SignUp3: DrawableResource
        get() = Res.drawable.img_sign_up_3
}
